import React, { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import useCeo from "../../hooks/useCEO";
import { AuthContext } from "../../context/authContext/authContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faCircleMinus,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
// import carroIcono from "./../../assets/img/truck-icon.png";

import { useUnidades } from "../../hooks/test/useUnidades";
// import { Select as SelectComponent } from "../../components/Select";
import Select from "react-select";
import { Spinner } from "../../components/Spinner";
// import { Input } from "../../components/Input";
import { verifyJWT, verifyJWT2 } from "../../helpers/JWT";
import { Loader } from "../../components/Loader";
import { SocketContext } from "../../context/SocketContext";

const initialStateFormProgramarRuta = {
    unidad_id: "",
    destino: [],
    fecha_salida: "",
    hora_salida: "",
    chofer_id: "",
    cel_operador: "",
    tripulacion: [],
    cel_tripulacion: "",
    observaciones: "",
    tiendas: [],
    cedis_id: "",
    tripulante_nombre: "",
    tripulante_id: "",
    tripulante_numero: "",
    tipo_tripulante_id: "",
};

export const ProgramarViajesManuales = () => {
    useCeo({
        title: "Módulo de Administración de rutas",
        description: "Página de administración de rutas",
    });
    
    const [form, setForm] = useState(initialStateFormProgramarRuta);
    // const [cedis, setCedis] = useState([]);
    const [choferes, setChoferes] = useState([]);
    const { socket } = useContext(SocketContext);
    const [maniobristas, setManiobristas] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [cat_tiendas, setCatTiendas] = useState([]);
    const [destinoSeleccionado] = useState("");
    const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
    const [isChecked, setIsChecked] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const { user, negocioSeleccionado } = useContext(AuthContext);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const  cedis_id  = user.cedis_id
    const {
    // fecha_salida,
    // hora_salida,
    chofer_id,
    tripulacion,
    observaciones,
    tripulante_id,
    tripulante_numero,
    tripulante_nombre,
    tipo_tripulante_id,
    } = form;
    
    const {
    getTripulacion,
    getChoferes,
    postChofer,
    postManiobrista,
    getUnits,
    getTiendasHub,
    postViaje,
    postTipulantes,
    createRutas,
    postBitacora,
    postCheckPrueba,
    putManiobrista,
    putchofer,
    postTripulantes,
    } = useUnidades();
    
    useEffect(() => {
        loadInfo();
        obtenerChofer();
        obtenerTripulante();
        return () => {
        cleanUp();
        };
    }, []);

    const cleanUp = () => {
    setForm(initialStateFormProgramarRuta);
    setTiendasSeleccionadas([]);
    setCatTiendas([]);
    setManiobristas([]);
    setUnidades([]);
    setChoferes([]);
    setIsChecked(true);
    }

    const loadInfo = async () => {
    setLoading(true);
    let resp = await getTiendasHub(cedis_id);
    if (resp.ok) {
        setCatTiendas(resp.tiendas);
    } else {
        setCatTiendas([]);
    }

    resp = await getUnits();
    if (resp.ok) {
        setUnidades([...resp.unidades]);
    } else {
        setUnidades([]);
        
    }

    setLoading(false);
    };

    const obtenerChofer = async () => {
    let resp = await getChoferes();
    if (resp.ok) {
        setChoferes(resp.choferes);
    } else {
        setChoferes([]);
    }
    };

    const obtenerTripulante = async () => {
    let resp = await getTripulacion();
    if (resp.ok) {
        setManiobristas(resp.tripulantes);
    } else {
        setManiobristas([]);
    }
    };

    const handleChange = (event) => {
    setForm({
        ...form,
        [event.target.name]: event.target.value,
    });
    };

    const addTienda = (tienda) => {
    setTiendasSeleccionadas([...tiendasSeleccionadas, tienda]);
    };
    const removeTienda = (index) => {
    let auxTiendas = tiendasSeleccionadas;
    auxTiendas.splice(index, 1);
    setTiendasSeleccionadas([...auxTiendas]);
    };
    const drawTienda = (tienda) => {
    let find = cat_tiendas.find((x) => x.tienda_id === parseInt(tienda));
    if (!find) return "Sin nombre";
    return find.tienda_nombre;
    };

    const resetForm = () => {
    setForm(initialStateFormProgramarRuta);
    setTiendasSeleccionadas([]);
    setCatTiendas([]);
    setManiobristas([]);
    setUnidades([]);
    setChoferes([]);
    loadInfo();
    setIsChecked(true);
    };

    const saveForm = async (event) => {
    event.preventDefault();
    let fecha = Date.now();
    const flag = validaciones();
    if (!flag) {
        return "";
    }
    setLoading(true);
    let resp = await postViaje({
        ...form,
        unidad_id: form.unidad_id,
        chofer_id: form.chofer_id,
        cedis_id: cedis_id,
        descripcion: form.observaciones,
        // fecha_hora_salida: form.fecha_salida + " " + form.hora_salida,
        fecha_hora_salida: fecha,
        status_id: 6,
    });

    // resp = await putViajeStatus(resp.viaje_id, 3);

    if (!resp.ok) return;
    let viajeId = resp.viaje_id;
    if (form.tripulacion.length > 0) {
        resp = await postTipulantes({
        id_viaje: viajeId,
        tripulantes: form.tripulacion,
        });
    }

    if (tiendasSeleccionadas.length > 0) {
        resp = await createRutas({
        viaje_id: viajeId,
        tiendas: tiendasSeleccionadas,
        });
    }
    await postBitacora({
        id_viaje: viajeId,
        notas: "El viaje ha sido creado con éxito",
        id_status: 6,
    });

    const [ok, userId] = verifyJWT(localStorage.getItem("x-token"));
    let monitorista_id = userId;
    let guardia_id = userId;
    if (ok) {
    }
    resp = await postCheckPrueba({
        viaje_id: viajeId,
        guardia_id: guardia_id,
        monitorista_id: monitorista_id,
        paro_motor: true,
        boton_panico: true,
        conectividad: true,
    });

    if(user.roles_id === 2) {
      socket.emit("traer-unidades-en-ruta_", { idNegocio: parseInt(negocioSeleccionado)});
    } else {
      socket.emit("traer-unidades-en-ruta_", { idNegocio: user.negocio_id});
    }

    resetForm();
    setLoading(false);

    return Swal.fire({
        title: "La unidad ha sido programada",
        text: "El viaje ha sido creado con éxito",
        icon: "success",
    });
    };

    const actualizarTripulante = async (event) => {
    event.preventDefault();
    if (tripulante_numero.length !== 10) {
        return Swal.fire({
        title: "No se puede actualizar registro",
        text: "Debe ser 10 digitos el telefono",
        icon: "error",
        });
    }
    setLoader(true);
    let resp = [];
    if (tipo_tripulante_id === 1) {
        resp = await putchofer({
        tripulante_id: tripulante_id,
        nombre_completo: tripulante_nombre,
        telefono: tripulante_numero,
        disponible: 1,
        negocio_id: 2,
        cedis_id: form.cedis_id ? form.cedis_id : null,
        });
    } else {
        resp = await putManiobrista({
        tripulante_id: tripulante_id,
        nombre_completo: tripulante_nombre,
        telefono: tripulante_numero,
        disponible: 1,
        negocio_id: 2,
        cedis_id: form.cedis_id ? form.cedis_id : null,
        });
    }

    if (resp) {
        obtenerTripulante();
        obtenerChofer();
        if (tipo_tripulante_id === 1) {
        pintarChofer(resp.tripulante_id);
        } else {
        pintarTripulante(resp.tripulante_id);
        }

        setLoader(false);
        return Swal.fire({
        title: "Se actualizo el tripulante",
        text: "Tripulante actualizado con exito",
        icon: "success",
        });
    } else {
        setLoader(false);
        return Swal.fire({
        title: "No se pudo actualizar al tripulante",
        text: "No se actualizo registro",
        icon: "error",
        });
    }
    };

    const showToastError = (msj = "Ha ocurrido un error") => {
    toast.error(msj, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    };

    const validaciones = () => {
    // if (!form.cedis_id) {
    //   showToastError("La cedis es obligatoria");
    //   return false;
    // }
    if (!form.unidad_id) {
        showToastError("La unidad es obligatoria");
        return false;
    }
    if (!form.chofer_id) {
        showToastError("Indica el nombre del operador");
        return false;
    }
    let find = form.tripulacion.find((x) => !x.tripulante_id);
    if (find) {
        showToastError("Selecciona un tripulante");
        return false;
    }

    // if (!form.fecha_salida) {
    //   showToastError("La fecha de salida es obligatoria");
    //   return false;
    // }
    // if (!form.hora_salida) {
    //   showToastError("La hora de salida es obligatoria");
    //   return false;
    // }
    if (tiendasSeleccionadas.length === 0) {
        showToastError("No se ha seleccionado ningún destino");
        return false;
    }

    return true;
    };

    const pintarChofer = () => {
        let find = choferes.find(
            (x) => x.disponible === 1 && x.tripulante_id === form.chofer_id
        );
        if (find)
        return (
        <>
            <h6 className="mb-1">Operador</h6>
            <h5 className="text-warning">
            {find.nombre_completo} - {find.telefono}
            {"  "}
            <i
                className="fa-solid fa-user-pen fa-circle-minus text-success ml-3"
                onClick={() => {
                handleShow();
                setForm({
                    ...form,
                    tripulante_nombre: find.nombre_completo,
                    tripulante_numero: find.telefono,
                    tripulante_id: find.tripulante_id,
                    tipo_tripulante_id: find.tipo_tripulante_id,
                });
                }}
            ></i>
            </h5>
        </>
        );
        return (
        <>
        <h6 className="mb-1">Operador *</h6>
        <h5 className="text-warning">Sin operador</h5>
        </>
        );
    };
    const pintarTripulante = (tripulante_id) => {
        let find = maniobristas.find(
            (x) => x.disponible === 1 && x.tripulante_id === tripulante_id
        );

        if (find)
        return (
        <>
            <h5 className="text-warning">
            <i
                className="fa-solid fa-circle-minus text-danger ml-3"
                onClick={() => {
                let arrayTripulacion = tripulacion;
                let index = arrayTripulacion.findIndex(
                    (x) => x.tripulante_id === tripulante_id
                );
                if (index >= 0) {
                    arrayTripulacion.splice(index, 1);
                    if (arrayTripulacion.length === 0) setIsChecked(true);
                    return handleChange({
                    target: {
                        name: "tripulacion",
                        value: arrayTripulacion,
                    },
                    });
                }
                }}
            ></i>{" "}
            {find.nombre_completo} - {find.telefono}{" "}
            <i
                className="fa-solid fa-user-pen fa-circle-minus text-success ml-3"
                onClick={() => {
                handleShow();
                setForm({
                    ...form,
                    tripulante_nombre: find.nombre_completo,
                    tripulante_numero: find.telefono,
                    tripulante_id: find.tripulante_id,
                    tipo_tripulante_id: find.tipo_tripulante_id,
                });
                }}
            ></i>
            </h5>
        </>
        );
        return (
            <>
            <h5 className="text-warning">Sin operador</h5>
            </>
        );
    };

    return (
        <>
          {loading && <Spinner />}
          {loader && <Loader />}
          <div className="col-12 col-md-6 col-lg-5 mx-auto p-4">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div
                    className="card-header text-center"
                    style={{ background: "#ffcd00" }}
                  >
                    Programar ruta
                  </div>
                  <div className="card-body">
                    <form onSubmit={saveForm}>
                      {/* <hr className="mb-3"></hr>
                      <h5>Hubs *</h5> */}
                      {/* <SelectComponent
                        name="cedis_id"
                        placeholder="Selecciona un hub"
                        classNamePrefix={"select"}
                        value={form.cedis_id}
                        onChange={(event) => {
                          handleChange(event);
                          cargaTiendasUnidades(event.target.value);
                        }}
                        options={cedis.map((x) => {
                          return { value: x.cedis_id, text: x.nombre_cedis };
                        })}
                        className="form-control selectCedis mb-4"
                      ></SelectComponent> */}
                      <hr className="mb-3"></hr>
                      <h5>Unidades *</h5>
                      <select
                        name="unidad_id"
                        // value={form.unidad_id}
                        className="form-control selectCedis mb-4"
                        onChange={handleChange}
                      >
                        <option value="">
                          Selecciona una unidad
                          {/* {!form.cedis_id
                            ? "Selecciona un hub primero"
                            : "Selecciona una unidad"} */}
                        </option>
                        {unidades.map((unidad) => {
                          return (
                            <option
                              key={unidad.unidad_id}
                              disabled={
                                unidad.unidad_disponible === 1 ? false : true
                              }
                              value={unidad.unidad_id}
                            >
                              {unidad.unidad_numero}
                              {!unidad.unidad_disponible ? " (No Disponible)" : ""}
                              {unidad.baja ? " (Deshabilitada)" : ""}
                            </option>
                          );
                        })}
                      </select>
                      <hr className="mb-3"></hr>
                      <div className="card inherit">
                        <div
                          className="card-header text-center text-white"
                          id="card-header"
                        >
                          TRIPULACIÓN
                        </div>
                        <br />
                        <div className="separacion">
                          <div className="row">
                            <div className="col-12 form-control selectCedis mb-4">
                              <Select
                                options={choferes.map((chofer) => {
                                  if (chofer.disponible === 1)
                                    return {
                                      value: chofer.tripulante_id,
                                      label: `${chofer.nombre_completo} ${chofer.telefono}`,
                                    };
                                  return {};
                                })}
                                className="mb-2"
                                classNamePrefix={"select"}
                                name="chofer_id"
                                value={chofer_id}
                                onChange={(elemento) => {
                                  setForm({ ...form, chofer_id: elemento.value });
                                }}
                                placeholder="Selecciona un operador"
                                noOptionsMessage={() => (
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      Swal.fire({
                                        title:
                                          "Ingresa los datos del operador a crear.",
                                        showCancelButton: true,
                                        confirmButtonText: "Registrar",
                                        showLoaderOnConfirm: true,
                                        html: `
                                  <label>Nombre completo</label>
                                  <input type="text" id="nombre_completo" className="form-control" placeholder="Nombre completo">
                                  <label>Teléfono</label>
                                  <input type="number" id="telefono" className="form-control" placeholder="Teléfono">`,
                                        preConfirm: () => {
                                          const nombre_completo =
                                            Swal.getPopup().querySelector(
                                              "#nombre_completo"
                                            ).value;
                                          const telefono =
                                            Swal.getPopup().querySelector(
                                              "#telefono"
                                            ).value;
                                          if (!nombre_completo || !telefono) {
                                            Swal.showValidationMessage(
                                              `Por favor registra el nombre y el teléfono`
                                            );
                                          }
                                          return { nombre_completo, telefono };
                                        },
                                        allowOutsideClick: () => !Swal.isLoading(),
                                      }).then(async (result) => {
                                        if (!result.value) return;
                                        const { nombre_completo, telefono } =
                                          result.value;
                                        if (result.isConfirmed) {
                                          if (telefono.length !== 10) {
                                            return Swal.fire({
                                              title:
                                                "No se puede crear el registro",
                                              text: "Debe ser 10 digitos el télefono",
                                              icon: "error",
                                            });
                                          }
                                          // let resp = await postChofer({
                                          //   nombre_completo,
                                          //   telefono,
                                          //   disponible: 1,
                                          //   negocio_id: 1,
                                          //   cedis_id: cedis_id,
                                          // });

                                          let resp = await postTripulantes({
                                            "nombre_completo": nombre_completo,
                                            "telefono": telefono,
                                            "cedis_id": user.cedis_id,
                                            "tipo_tripulante_id": 1,
                                            "negocio_id": user.negocio_id,
                                          });
    
                                          if (resp.tripulante_id) {
                                            setForm({
                                              ...form,
                                              chofer_id: resp.tripulante_id,
                                            });
                                            let resp1 = await getChoferes();
    
                                            if (resp1.ok) {
                                              setChoferes(resp1.choferes);
                                            } else {
                                              setChoferes([]);
                                            }
                                            return Swal.fire({
                                              title: `Chofer creado con éxito`,
                                              text: resp.msg,
                                              icon: "success",
                                            });
                                          }
                                          return Swal.fire({
                                            title: `No se pudo crear el chofer`,
                                            text: resp.msg,
                                            icon: "error",
                                          });
                                        }
                                      })
                                    }
                                  >
                                    Registrar operador
                                  </button>
                                )}
                              />
                            </div>
                            <div className="col-12">{pintarChofer()}</div>
                          </div>
    
                          <div className="row my-2">
                            <div className="col-12">
                              <input
                                className=""
                                id="checkPasajeros"
                                type={"checkbox"}
                                checked={isChecked}
                                onChange={(event) => {
                                  setIsChecked(event.target.checked);
                                  if (event.target.checked)
                                    handleChange({
                                      target: {
                                        name: "tripulacion",
                                        value: [],
                                      },
                                    });
                                }}
                              ></input>
                              <label htmlFor="checkPasajeros" className="ps-2">
                                SIN TRIPULACIÓN
                              </label>
                            </div>
                          </div>
                          {!isChecked && (
                            <>
                              <div className="col-12 form-control mb-4 selectCedis">
                                <Select
                                  options={maniobristas.map((x) => {
                                    let find = tripulacion.find(
                                      (y) => y.tripulante_id === x.tripulante_id
                                    );
    
                                    if (x.disponible === 1)
                                      return {
                                        value: x.tripulante_id,
                                        label: `${x.nombre_completo} ${x.telefono}`,
                                        isDisabled: find ? true : false,
                                      };
                                    return {};
                                  })}
                                  className="mb-2"
                                  classNamePrefix={"select"}
                                  name="chofer_id"
                                  value={chofer_id}
                                  onChange={(elemento) => {
                                    if (tripulacion.length > 2)
                                      return Swal.fire({
                                        title:
                                          "¡Lo siento!",
                                        text: "Solo se pueden agregar hasta 3 maniobras",
                                        icon: "info",
                                      });
                                    const arrayTripulacion = tripulacion;
                                    arrayTripulacion.push({
                                      tripulante_id: elemento.value,
                                    });
                                    handleChange({
                                      target: {
                                        name: "tripulacion",
                                        value: arrayTripulacion,
                                      },
                                    });
                                  }}
                                  placeholder="Selecciona tus tripulantes"
                                  noOptionsMessage={() => (
                                    <button
                                      className="btn"
                                      onClick={() =>
                                        Swal.fire({
                                          title:
                                            "Ingresa los datos del tripulante a registrar.",
                                          showCancelButton: true,
                                          confirmButtonText: "Registrar",
                                          showLoaderOnConfirm: true,
                                          html: `
                                  <label>Nombre completo</label>
                                  <input type="text" id="nombre_completo" className="form-control" placeholder="Nombre completo">
                                  <label>Teléfono</label>
                                  <input type="number" id="telefono" className="form-control" placeholder="Teléfono">`,
                                          preConfirm: () => {
                                            const nombre_completo =
                                              Swal.getPopup().querySelector(
                                                "#nombre_completo"
                                              ).value;
                                            const telefono =
                                              Swal.getPopup().querySelector(
                                                "#telefono"
                                              ).value;
                                            if (!nombre_completo || !telefono) {
                                              Swal.showValidationMessage(
                                                `Por favor registra el nombre y el teléfono`
                                              );
                                            }
                                            return { nombre_completo, telefono };
                                          },
                                          allowOutsideClick: () =>
                                            !Swal.isLoading(),
                                        }).then(async (result) => {
                                          if (!result.value) return;
                                          const { nombre_completo, telefono } =
                                            result.value;
                                          if (result.isConfirmed) {
                                            if (telefono.length !== 10) {
                                              return Swal.fire({
                                                title:
                                                  "No se puede crear el registro",
                                                text: "Debe ser 10 digitos el telefono",
                                                icon: "error",
                                              });
                                            }
                                            // let resp = await postManiobrista({
                                            //   nombre_completo,
                                            //   telefono,
                                            //   disponible: 1,
                                            //   negocio_id: 1,
                                            //   cedis_id: cedis_id,
                                            // });

                                            let resp = await postTripulantes({
                                              "nombre_completo": nombre_completo,
                                              "telefono": telefono,
                                              "cedis_id": user.cedis_id,
                                              "tipo_tripulante_id": 2,
                                              "negocio_id": user.negocio_id,
                                            });
    
                                            // Continuar aquí
                                            if (resp.tripulante_id) {
                                              const arrayTripulacion = tripulacion;
                                              if (tripulacion.length < 3) {
                                                arrayTripulacion.push({
                                                  tripulante_id: resp.tripulante_id,
                                                });
                                              }
    
                                              /*Trae los tripulantes para seleccionar */
                                              let resp1 = await getTripulacion();
                                              if (resp1.ok) {
                                                setManiobristas(resp1.tripulantes);
                                              } else {
                                                setManiobristas([]);
                                              }
    
                                              if (tripulacion.length > 2) {
                                                return Swal.fire({
                                                  title: "Se creó el tripulante",
                                                  text: "Se pudo crear pero no se pudo añadir a tu lista ya que solo se permite elegir 3 operadores, retira uno y selecciona el creado",
                                                  icon: "warning",
                                                });
                                              } else {
                                                handleChange({
                                                  target: {
                                                    name: "tripulacion",
                                                    value: arrayTripulacion,
                                                  },
                                                });
    
                                                return Swal.fire({
                                                  title: `Tripulante creado con éxito`,
                                                  text: resp.msg,
                                                  icon: "success",
                                                });
                                              }
                                            }
                                            return Swal.fire({
                                              title: `No se pudo crear el tripulante`,
                                              text: resp.msg,
                                              icon: "error",
                                            });
                                          }
                                        })
                                      }
                                    >
                                      Registrar tripulante
                                    </button>
                                  )}
                                />
                              </div>
                              {tripulacion.map((x) => {
                                return (
                                  <label key={x.tripulante_id} className="mt-0">
                                    {pintarTripulante(x.tripulante_id)}
                                  </label>
                                );
                              })}
                            </>
                          )}
                          <br />
                        </div>
                      </div>
                      <hr className="mb-3"></hr>
                      <h5>Selecciona tienda(s) *</h5>
    
                      <Select
                        options={cat_tiendas.map((x) => {
                          let tienda = tiendasSeleccionadas.find(
                            (y) => y === x.tienda_id
                          );
    
                          return {
                            value: x.tienda_id,
                            label: `${x.id}  ${x.tienda_nombre}`,
                            isDisabled: tienda ? true : false,
                          };
                        })}
                        className="mb-2"
                        classNamePrefix={"select"}
                        name="destino"
                        value={destinoSeleccionado}
                        onChange={(elemento) => {
                          addTienda(elemento.value);
                        }}
                        placeholder="Selecciona una tienda"
                        // placeholder={
                        //   !form.cedis_id
                        //     ? "Selecciona un hub primero"
                        //     : "Selecciona una tienda"
                        // }
                      />
    
                      <br />
                      {tiendasSeleccionadas.map((tienda, index) => {
                        return (
                          <div key={index}>
                            <p className="mb-3">
                              <button
                                type="button"
                                className="btn"
                                onClick={() => {
                                  removeTienda(index);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faCircleMinus}
                                  className="fa-sm"
                                  style={{ color: "red  " }}
                                ></FontAwesomeIcon>
                              </button>
                              &nbsp;
                              <small>{drawTienda(tienda)}</small>
                            </p>
                          </div>
                        );
                      })}
                      {tiendasSeleccionadas.length > 0 ? (
                        <>
                          <button
                            type="button"
                            onClick={() => {
                              setTiendasSeleccionadas([...[]]);
                            }}
                            className="btn btn-danger-b btn-block"
                          >
                            <FontAwesomeIcon icon={faTrashAlt} /> &nbsp; Borrar
                          </button>
                          <br />
                        </>
                      ) : (
                        <>
                          <p className="text-warning text-center">
                            <small>No se ha seleccionado ningún destino</small>
                          </p>
                        </>
                      )}
                      {/* <hr className="mb-3"></hr>
                      <h5>Fecha/Hora de salida *</h5>
                      {/* <label>FECHA DE SALIDA*</label> */}
                      {/* <Input
                        attribute={{
                          name: "fecha_salida",
                          type: "date",
                          className: "form-control control-input",
                          id: "fechaActual",
                        }}
                        value={fecha_salida}
                        onChange={handleChange}
                      />
                      <br></br>
                      {/* <label>HORA DE SALIDA*</label> */}
                      {/* <Input
                        attribute={{
                          id: "idHoraSalida",
                          name: "hora_salida",
                          type: "time",
                          className: "form-control control-input",
                        }}
                        value={hora_salida} 
                        onChange={handleChange}
                      /> */}
                      <hr className="mb-3"></hr>
                      <h5>Comentarios/Observaciones</h5>
                      <textarea
                        className="form-control control-input mt-2"
                        placeholder="DESCRIPCIÓN DE LA UNIDAD O SALIDA"
                        name="observaciones"
                        value={observaciones}
                        onChange={handleChange}
                      ></textarea>
                      <br />
                      {/* <input
                        type="hidden"
                        value={user.cedis_id}
                        name="cedis_id"
                      ></input> */}
                      <div className="card-footer bg-transparent border-dark text-center">
                        <div className="text-center">
                          <button
                            id="liberarSalida"
                            type="submit"
                            className="btn btn-block liberarSalida"
                            style={{ background: "#ffcd00" }}
                          >
                            <FontAwesomeIcon icon={faTruck} />
                            &nbsp; Liberar viaje
                          </button>
                          <br />
                        </div>
                        <br />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                ACTUALIZAR {tipo_tripulante_id === 1 ? "OPERADOR" : "TRIPULANTE"}
              </Modal.Title>
            </Modal.Header>
            <form onSubmit={actualizarTripulante}>
              <Modal.Body>
                <div className="main">
                  <div className="mb-3">
                    <label className="col-form-label">Nombre del tripulante</label>
    
                    <input
                      readOnly
                      name="tripulante_nombre"
                      type="text"
                      className="form-control control-input"
                      value={tripulante_nombre}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="col-form-label">Numero del tripulante</label>
                    <input
                      name="tripulante_numero"
                      required
                      type="number"
                      className="form-control control-input"
                      value={tripulante_numero}
                      onChange={handleChange}
                    />
    
                    <input
                      name="tripulante_id"
                      type="hidden"
                      className="form-control control-input"
                      value={tripulante_id}
                    />
    
                    <input
                      name="tipo_tripulante_id"
                      type="hidden"
                      className="form-control control-input"
                      value={tipo_tripulante_id}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="row justify-content-center">
                  <div className="col-6">
                    <Button variant="secondary" onClick={handleClose}>
                      Cancelar
                    </Button>
                  </div>
                  <div className="col-6">
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleClose();
                      }}
                      type="submit"
                    >
                      Confirmar
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
        </>
    );

};